import { useMutation, UseMutationResult, useQueryClient } from 'react-query';

import { getTokenWithType } from './useAuth';

import { importBlobFiles } from '../utils/urls';

import { ErrorModal } from 'types/modalTypes';
import { BlobType } from 'types/procedureBuilder';

export async function postImportFiles({
  params,
  accountId,
}: TVariables): Promise<TResult> {
  const response = await fetch(importBlobFiles(accountId), {
    method: 'POST',
    headers: {
      Authorization: getTokenWithType(),
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(params),
  });
  return response.json();
}

type TError = ErrorModal;

type TResult = {
  Data: string;
  IsSuccess: boolean;
  StatusCode: number;
} & ErrorModal;

type TVariables = {
  params: {
    DestinationPath: string;
    BlobDirectoryList: Array<BlobType>;
  };
  accountId: number;
};

type TSnapshot = unknown;

function useImportBlobFiles(): UseMutationResult<
  TResult,
  TError,
  TVariables,
  TSnapshot
> {
  const queryClient = useQueryClient();
  return useMutation(async ({ params, accountId }: TVariables) => {
    const postResult = await postImportFiles({
      params,
      accountId,
    });

    if (postResult.Data) {
      queryClient.invalidateQueries(['get_file_tree'], {
        refetchInactive: true,
      });
      queryClient.removeQueries(['get_accounts_list_for_import_files']);
    } else if (postResult.Errors) throw postResult;
    return postResult;
  });
}

export { useImportBlobFiles };
